import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChatbotPageContainerComponent } from './features/chatbot-fullscreen/containers/chatbot-page.container';

const routes: Routes = [{ path: '', component: ChatbotPageContainerComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TalkToYourDataRoutingModule {}
